@if (!loggedIn) {
    <div class="flex justify-center items-center h-[100%]">
        <div class="flex flex-col items-center justify-center">
            <div
                class="flex flex-col gap-2 items-center w-[84vw] sm:w-[60vw] min-h-[360px] py-3 bg-[var(--background-primary-color)] rounded-lg border-[1px] border-[var(--header-border)]">

                @if (!logoId) {
                    <img class="h-[70px] w-auto pl-2 mt-4 cursor-pointer" src="./../../../assets/logo/logo_full.png" alt="logo"
                        [routerLink]="['/home']">
                } @else {
                    <div class="h-[70px] w-auto pl-2 mt-4 cursor-pointer" routerLink="/home">
                        <image [id]="logoId" [props]="'h-[70px] w-auto'"></image>
                    </div>
                }

                <p class="title my-3">Reset Your Password</p>

                <div class="flex flex-col flex-wrap w-[84%] sm:w-[70%] gap-4">
                    <text-field placeholder="Password" label="Password" [control]="getControl('password')"
                        [type]="passwordType">
                    </text-field>

                    <text-field placeholder="Confirm Password" label="Confirm Password"
                        [control]="getControl('confirmPassword')" [error]="getErrorMessage('confirmPassword')"
                        [type]="passwordType">
                    </text-field>

                    <p class="w-full flex flex-col gap-2">
                        <checkbox class="mr-2" [value]="showPasswords" label="Show Passwords" (change)="toggleType()">
                        </checkbox>
                    </p>
                </div>

                <common-button (click)="submit()" class="my-2" label="Submit" size="L"
                    [disabled]="user.invalid || mismatch">
                </common-button>
            </div>
        </div>
    </div>
}
